import { redirectToInternalLink, redirectToExternalLink, currentPage } from './redirector';
import { userLoggedIn, userLoggedOut, userLoggedInProcessFinished } from '../actions/user';
import { registerPubnub, unsubscribeAllPubnub, disposePubNub } from '../actions/pubnub/init';
import { startPubnubHealthMonitor, stopPubnubHealthMonitor } from '../actions/networkHealthStatus';
import { getHomePanelMeetingRooms } from '../actions/meetingRoom.js';
import { reportInitialState } from '../store/initialState';
import { sendESEventsBunch } from 'businessLogic/logEventToElasticSearch';
import {
  validateSelfProvisionLink,
  validateSelfProvisionResponseForExistingUser,
  selfProvisionModelForExistingUser,
  validateSelfProvisionLinkOnSessionTimeOut,
} from './selfProvision.js';
import { getWaitingAreas, selectWaitingArea, getWaitingArea } from '../actions/waitingArea.js';
import {
  updateShowQuickViewModal,
  updateHideWhenClickAwayQuickView,
  updateShowforgetPasswordModal,
} from '../actions/modal';
import { getUserBasicProfile, setResetPasswordToken, updateUserProfileWithNewEmail } from '../actions/user';
import { displayGlobalMessage } from '../actions/globalMessage.js';
import { setPubnubHeartbeatReceived } from '../actions/networkHealthStatus';
import fc from './fetchInterceptor';
import { queueESEvents, ESEventTypes } from './logEventToElasticSearch';
import moment from 'moment';
import jwtDecode from 'jwt-decode';

const homePage = '/organisational-unit/view-all';

// TODO - where is this method being used?
// let pageWithNoHashAndInRoot = () => {
//   let isGoodPage = false;
//   if (!window.location.href.indexOf('#') > -1) { //if the page doesnt have a hash on it
//     if (window.location.pathname == "/")
//       isGoodPage = true;
//   }
//   return isGoodPage;
// }
export let getUrlParameter = (name) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

let authorize = (res, dispatcher, doNotRedirect, getBasicProfile = true) => {
  //this is executed upon EVERY NAVIGATION REQUEST

  var selfProvisionWA = getUrlParameter('selfProvisionWA');
  if (!selfProvisionWA) {
    //if there is no self provision token, then proceed with rest of the code
    processAuthorization(res, dispatcher, doNotRedirect, false, {}, getBasicProfile);
  } else {
    //so there is self provision token,
    //PROCESSAUTHORIZATION WILL BE CALLED FROM The following FUNCTION
    validateSelfProvisionLink(res, dispatcher, doNotRedirect);
  }
};

let setAuthenticationDetails = (sessionToken, serverTimeUtc, subscribeKey, dispatcher) => {
  //This function will set your login details
  var serverTimeUtc = new Date(serverTimeUtc);
  var localTimeUtc = new Date();
  var serverClientTimeDiffMilliSeconds = serverTimeUtc.getTime() - localTimeUtc.getTime();

  // save the jwt token to local storage
  window.localStorage.setItem('token', sessionToken);
  window.localStorage.setItem('serverClientTimeDiffMilliSeconds', serverClientTimeDiffMilliSeconds);
  window.localStorage.setItem('subscribeKey', subscribeKey);
};

export let processAuthorization = (
  res,
  dispatcher,
  doNotRedirect,
  isTokenValid,
  selfProvisionResponse,
  getBasicProfile
) => {
  if (res && res.sessionToken) {
    // login request was processed and successful response is available
    setAuthenticationDetails(res.sessionToken, res.serverTimeUtc, res.subscribeKey, dispatcher);
    var redirectPathInfo = getUrlParameter('path_info');

    if (redirectPathInfo && redirectPathInfo.length > 0) {
      redirectToExternalLink(redirectPathInfo);
      return;
    }

    canIUseVCM(dispatcher, getBasicProfile).then(
      ({
        hasWaitingAreas,
        hasMeetingRooms,
        hasOrganisations,
        hasReports,
        loggedInPersonEmail,
        shouldLoadDirectlyAssociatedWAs,
      }) => {
        if (hasWaitingAreas || hasMeetingRooms || hasOrganisations || hasReports) {
          let userWanterPage = window.sessionStorage.getItem('userWantedPage');
          let isUserWanterPageSignUp = userWanterPage && userWanterPage.indexOf('/signup') > -1 ? true : false;

          if (userWanterPage != 'undefined' && userWanterPage != null && !isUserWanterPageSignUp) {
            if (
              window.sessionStorage.userWantedPage == '/' ||
              window.sessionStorage.userWantedPage.toLowerCase() == '/login'
            ) {
              // dont do anything, this way user will be presented with quick view page
              userRedirectPageAfterLogin(
                dispatcher,
                hasWaitingAreas,
                hasMeetingRooms,
                hasOrganisations,
                hasReports,
                loggedInPersonEmail,
                isTokenValid,
                selfProvisionResponse,
                shouldLoadDirectlyAssociatedWAs
              );
            }
            if (!doNotRedirect) {
              window.$('#overlay').fadeOut();
              dispatcher(userLoggedIn());
              redirectToInternalLink(userWanterPage);
              window.sessionStorage.removeItem('userWantedPage');
            }
          } else {
            // if no page specified, go to home page

            // If the user is loggedIn and the user want to go to the "/"
            // do not show login page
            if (!doNotRedirect && !isUserWanterPageSignUp) {
              dispatcher(userLoggedIn());
              redirectToInternalLink(homePage);
            } else {
              userRedirectPageAfterLogin(
                dispatcher,
                hasWaitingAreas,
                hasMeetingRooms,
                hasOrganisations,
                hasReports,
                loggedInPersonEmail,
                isTokenValid,
                selfProvisionResponse,
                shouldLoadDirectlyAssociatedWAs
              );
            }
          }
          registerPubnub(res.subscribeKey, dispatcher);
          startPubnubHealthMonitor(dispatcher);
        }
      }
    );
  } else if (!loggedIn()) {
    //this means the user tried to visit a page, but the token didnt exist, so we redirect back to login, if this is NOT the login page
    var resetToken = getUrlParameter('resetToken');
    var forgotPassword = getUrlParameter('forgotPassword');
    if (resetToken) {
      try {
        //we put in try catch, so if any error occurs in validating reset token, it should not have any impact to the flow of application
        let jwtTokenDecoded = jwtDecode(resetToken);
        var ExpiryTimeLocal = /\(([^)]+)\)/.exec(jwtTokenDecoded.ExpriyTime);
        jwtTokenDecoded.ExpiryTimeLocal = parseInt(ExpiryTimeLocal[1], 10);

        dispatcher(setResetPasswordToken(jwtTokenDecoded, resetToken));
      } catch (ex) {
        console.error('reset token is not valid', ex);
      }
    } else if (forgotPassword.toLowerCase() == 'true') {
      dispatcher(updateShowforgetPasswordModal(true));
    }

    //do not redirect to login when visiting login
    let isQuickViewModalShown = window.getState().modalReducer.showQuickViewModal;

    if (!isUserOnLoginPage() || isQuickViewModalShown) {
      if (currentPage() != '/') {
        //do not set current page when visiting root
        window.sessionStorage.setItem('userWantedPage', currentPage());
      }

      if (isUserOnVerifyEmailPage()) {
        verifyChangeEmailRequestLink(dispatcher);
      } else if (!doNotRedirect) {
        logout(dispatcher);
      }
    } else if (isUserOnLoginPage() && !loggedIn()) {
      window.onpopstate = function (event) {
        if (isUserOnLoginPage() && !loggedIn()) {
          logout(dispatcher);
          redirectToLoginPage();
        }
      };
    }
    window.$('#overlay').fadeOut();
  } else if (loggedIn()) {
    // this else means the user didnt go through login process, went to login, the login already existed, therefore redirect to home page
    let jwtToken = window.localStorage.getItem('token');
    var serverClientTimeDiffMilliSeconds = window.localStorage.getItem('serverClientTimeDiffMilliSeconds');

    try {
      var parsedDate = /\(([^)]+)\)/.exec(jwtDecode(jwtToken).ExpriyTime);
      parsedDate = parseInt(parsedDate[1], 10);

      var currentDateClient = new Date();
      var expirationDateServer = new Date(parsedDate);
      var expirationDateClient = new Date(expirationDateServer.getTime() - Number(serverClientTimeDiffMilliSeconds));

      if (currentDateClient >= expirationDateClient) {
        //token expired, logout
        // console.log('Token expired, logout now');
        // window.localStorage.setItem('userWantedPage', currentPage());
        //when session time outs and user sign in back, dashboard will be shown.
        if (window.sessionStorage.getItem('userWantedPage') == '/') window.sessionStorage.removeItem('userWantedPage');
        logout(dispatcher);
      } else if (isUserOnLoginPage()) {
        //if login was visited and the user is logged in

        var redirectPathInfo = getUrlParameter('path_info');
        if (redirectPathInfo && redirectPathInfo.length > 0) {
          redirectToExternalLink(redirectPathInfo);
          return;
        }

        window.showingOverLay = true;
        canIUseVCM(dispatcher, getBasicProfile).then(
          ({ hasWaitingAreas, hasMeetingRooms, hasOrganisations, hasReports, loggedInPersonEmail }) => {
            if (hasWaitingAreas || hasMeetingRooms || hasOrganisations || hasReports) {
              dispatcher(userLoggedIn());
              userRedirectPageAfterLogin(
                dispatcher,
                hasWaitingAreas,
                hasMeetingRooms,
                hasOrganisations,
                hasReports,
                loggedInPersonEmail,
                isTokenValid,
                selfProvisionResponse
              );

              // TODO - After PR1, the redirect will be removed
              // dispatcher for quickview should be enabled again
              // dispatcher(updateShowQuickViewModal(true));
              // dispatcher(updateHideWhenClickAwayQuickView(false));
            }
          }
        );
      } else if (isUserOnVerifyEmailPage()) {
        verifyChangeEmailRequestLink(dispatcher);
      } else {
        canIUseVCM(dispatcher, getBasicProfile).then(
          ({ hasWaitingAreas, hasMeetingRooms, hasOrganisations, hasReports, loggedInPersonEmail }) => {
            if (hasWaitingAreas || hasMeetingRooms || hasOrganisations || hasReports) {
              if (!doNotRedirect) dispatcher(userLoggedIn());
            }
          }
        );
      }
    } catch (ex) {
      console.error('reset token is not valid', ex);
      logout(dispatcher);
    }
    if (window.localStorage.getItem('subscribeKey')) {
      registerPubnub(window.localStorage.getItem('subscribeKey'), dispatcher);
      startPubnubHealthMonitor(dispatcher);
    }
  }
};

let logout = (dispatcher) => {
  console.warn('===> logout called');
  // Hide all visible modal popups
  window.$('.modal:visible').modal('hide');
  sendESEventsBunch(false, true);

  if (window.fetchPromiseController) {
    try {
      window.fetchPromiseController.abort();
    } catch (err) {
      console.error('AbortController error', err);
    } finally {
      // Reset abort controller
      window.fetchPromiseController = null;
    }
  }

  if (window.timer !== undefined) {
    clearTimeout(window.timer);
    window.timer = undefined;
  }

  dispatcher(userLoggedOut());
  clearUserDetails();
  window.showingOverLay = true;
  window.$('#overlay').show(); //for displaying the spinner again

  // un-subscribe from all pubnub updates
  stopPubnubHealthMonitor(dispatcher);

  var selfProvisionWA = getUrlParameter('selfProvisionWA');
  if (selfProvisionWA) {
    //if self Provision url is there and session has timed out
    validateSelfProvisionLinkOnSessionTimeOut(dispatcher);
  } else if (currentPage().toLowerCase() == '/signup') {
    return;
  } else if (currentPage().toLowerCase() == '/verify-email') {
    return;
  } else {
    redirectToLoginPage();
  }
};

const redirectToLoginPage = () => {
  let redirectPathInfo = getUrlParameter('path_info');
  let loginPage = '/login';
  if (redirectPathInfo && redirectPathInfo.length > 0 && currentPage() == '/') {
    loginPage += '?path_info=' + redirectPathInfo;
  }
  // redirect to login view
  redirectToInternalLink(loginPage);
};

let userRedirectPageAfterLogin = (
  dispatcher,
  hasWaitingAreas,
  hasMeetingRooms,
  hasOrganisations,
  hasReports,
  loggedInPersonEmail,
  isTokenValid,
  selfProvisionResponse,
  shouldLoadDirectlyAssociatedWAs
) => {
  const totalPermissions = (hasMeetingRooms ? 1 : 0) + (hasWaitingAreas ? 1 : 0); //we only show Quick view if we have meetingroom and waiting area both
  const toDisplayWASelfProvisionModal = validateSelfProvisionResponseForExistingUser(
    dispatcher,
    loggedInPersonEmail,
    isTokenValid,
    selfProvisionResponse
  );

  //Show quick view only if self provision modal will not be shown and totalpermission is > 1
  if (totalPermissions > 1 && !toDisplayWASelfProvisionModal) {
    //Only display the quick view if you have permissions to more than one entity
    dispatcher(updateShowQuickViewModal(true));
    dispatcher(updateHideWhenClickAwayQuickView(true));
  }

  if (hasOrganisations && shouldLoadDirectlyAssociatedWAs) {
    if (!hasWaitingAreas) {
      dispatcher(updateShowQuickViewModal(true));
      redirectUserToOrgUnitfterLogin(dispatcher);
    } else {
      redirectUser(hasWaitingAreas, hasMeetingRooms, hasOrganisations, hasReports, dispatcher);
    }
  } else {
    redirectUser(hasWaitingAreas, hasMeetingRooms, hasOrganisations, hasReports, dispatcher);
  }

  if (toDisplayWASelfProvisionModal) {
    selfProvisionModelForExistingUser(dispatcher);
  }
};

const redirectUser = (hasWaitingAreas, hasMeetingRooms, hasOrganisations, hasReports, dispatcher) => {
  if (hasWaitingAreas) {
    redirectUserToWAAfterLogin(dispatcher);
  } else if (hasMeetingRooms) {
    redirectUserToMeetingRoomfterLogin(dispatcher);
  } else if (hasOrganisations) {
    redirectUserToOrgUnitfterLogin(dispatcher);
  } else if (hasReports) {
    redirectUserToReportsfterLogin(dispatcher);
  }
};

//End self provision Modal Dialogue

let clearUserDetails = () => {
  window.localStorage.removeItem('token');
  window.localStorage.removeItem('serverClientTimeDiffMilliSeconds');
  window.localStorage.removeItem('startDateForReport');
  window.localStorage.removeItem('endDateForReport');
  window.localStorage.removeItem('queuedEvents');
  window.localStorage.removeItem('unsentEvents');
  disposePubNub();
  reportInitialState.startDate = null;
  reportInitialState.endDate = null;
};

let loggedIn = () => {
  return window.localStorage.getItem('token') !== 'undefined' && window.localStorage.getItem('token') != null;
};

let getToken = () => {
  return loggedIn() ? window.localStorage.getItem('token') : undefined;
};

let getAuthHeaders = () => {
  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + getToken(),
  };
};

let setToken = (response, dispatcher) => {
  if (response.ok) {
    //if the response is ok

    var sessionToken = response.headers.get('SessionToken');
    var serverTimeUtcHeader = response.headers.get('ServerTimeUtc');

    // check if we need to replace JWT token on client end
    if (sessionToken && serverTimeUtcHeader) {
      var serverTimeUtc = new Date(serverTimeUtcHeader);
      var localTimeUtc = new Date();
      var serverClientTimeDiffMilliSeconds = serverTimeUtc.getTime() - localTimeUtc.getTime();

      // save token to local storage
      window.localStorage.setItem('token', sessionToken);
      window.localStorage.setItem('serverClientTimeDiffMilliSeconds', serverClientTimeDiffMilliSeconds);
    }
  }
};

let isUserOnLoginPage = () => {
  return window.location.href.toLowerCase().indexOf('login') > -1 || window.location.pathname === '/';
};

let isUserOnVerifyEmailPage = () => {
  return window.location.href.toLowerCase().indexOf('verify-email') > -1;
};

let isUserOnUserProfilePage = (store) => {
  return store.getState().modalReducer.showChangeUserProfileModal == true;
};

// TODO - after PR1, this function for redirecting to WA page after login should be removed
let redirectUserToWAAfterLogin = (dispatcher) => {
  const gotWaitingAreas = (waitingAreas) => {
    if (waitingAreas) {
      if (waitingAreas.length == 1) {
        let thisWaitingArea = null;
        thisWaitingArea = waitingAreas[0];
        dispatcher(selectWaitingArea(thisWaitingArea.id));
        queueESEvents(
          ESEventTypes.APICall,
          `In redirectUserToWAAfterLogin: ${thisWaitingArea.id}`,
          'eventType&apiURL',
          {
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + thisWaitingArea.id + '/calls',
            browserURL: window.location.href,
          },
          null,
          true,
          'info'
        );
        redirectToInternalLink(`waiting-area/view-one/${thisWaitingArea.id}`);
      } else {
        redirectToInternalLink('waiting-area/view-all');
      }
      dispatcher(userLoggedInProcessFinished());
    }
    window.$('#overlay').fadeOut();
  };
  dispatcher(getWaitingAreas(gotWaitingAreas));
};

// This is used for redirecting to only waitingarea/view-all without checking waiting areas number
let redirectUserToWaitingAreasfterLogin = (dispatcher) => {
  redirectToInternalLink('waiting-area/view-all');
  dispatcher(userLoggedInProcessFinished());
  window.$('#overlay').fadeOut();
};

let redirectUserToMeetingRoomfterLogin = (dispatcher) => {
  redirectToInternalLink('meeting-room/view-all');
  dispatcher(userLoggedInProcessFinished());
  window.$('#overlay').fadeOut();
};

let redirectUserToOrgUnitfterLogin = (dispatcher) => {
  redirectToInternalLink('/organisational-unit/view-all');
  dispatcher(userLoggedInProcessFinished());
  window.$('#overlay').fadeOut();
};

let redirectUserToReportsfterLogin = (dispatcher) => {
  redirectToInternalLink('report');
  dispatcher(userLoggedInProcessFinished());
  window.$('#overlay').fadeOut();
};

/////At the moment we allow login if the user has meeting room or waiting area
let canIUseVCM = (dispatcher, getBasicProfile = true, updateLastHeartbeatUTC = false) => {
  // updateLastHeartbeatUTC is true only when token authentication is called, e.g log in
  // for other scenario, e.g navigate to another tab then come back, will not set lastheartbeat when /basicInfo is called
  return new Promise((resolve, reject) => {
    const gotBasicProfile = (basicProfile) => {
      if (basicProfile) {
        if (
          !basicProfile.hasWaitingAreas &&
          !basicProfile.hasMeetingRooms &&
          !basicProfile.hasOrganisations &&
          !basicProfile.hasReports
        ) {
          dispatcher(
            displayGlobalMessage({
              text: APP.LANGUAGE.Login.canLoginToVCM,
              visible: true,
              messageType: 'Bad',
              gotItButtonText: APP.LANGUAGE.DismissGlobalMessageGood,
              gotItCallBack: canIUseVCMErrorMsgCallBack,
            })
          );
          window.localStorage.removeItem('token');
          window.localStorage.removeItem('serverClientTimeDiffMilliSeconds');
          return resolve({
            hasWaitingAreas: basicProfile.hasWaitingAreas,
            hasMeetingRooms: basicProfile.hasMeetingRooms,
            hasOrganisations: basicProfile.hasOrganisations,
            hasReports: basicProfile.hasReports,
            loggedInPersonEmail: basicProfile.email,
          });
        } else {
          let hasWaitingAreasDirectlyAssociated = true;
          let waitingAreasDirectlyAssociated = [];
          let waitingAreas = basicProfile.waitingAreas;

          if (basicProfile.hasEntityAdminRights.isOrgAdmin && basicProfile.shouldLoadDirectlyAssociatedWAs) {
            waitingAreasDirectlyAssociated = waitingAreas.filter(
              (waitingArea) => waitingArea.hasDirectAssociation === true
            );

            hasWaitingAreasDirectlyAssociated =
              waitingAreasDirectlyAssociated && waitingAreasDirectlyAssociated.length > 0;
          }
          return resolve({
            hasWaitingAreas:
              basicProfile.hasEntityAdminRights.isOrgAdmin && basicProfile.shouldLoadDirectlyAssociatedWAs
                ? hasWaitingAreasDirectlyAssociated
                : basicProfile.hasWaitingAreas,
            hasMeetingRooms: basicProfile.hasMeetingRooms,
            hasOrganisations: basicProfile.hasOrganisations,
            hasReports: basicProfile.hasReports,
            loggedInPersonEmail: basicProfile.email,
            shouldLoadDirectlyAssociatedWAs: basicProfile.shouldLoadDirectlyAssociatedWAs,
          });
        }
      } else {
        dispatcher(
          displayGlobalMessage({
            text: APP.LANGUAGE.Login.canLoginToVCM,
            visible: true,
            messageType: 'Bad',
            gotItButtonText: APP.LANGUAGE.DismissGlobalMessageGood,
            gotItCallBack: canIUseVCMErrorMsgCallBack,
          })
        );
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('serverClientTimeDiffMilliSeconds');
        return resolve(false, false);
      }
    };
    const userProfile = window.getState().usersReducer.userProfile;
    getBasicProfile = getBasicProfile || !userProfile.email || userProfile.email == '' ? true : false;
    //we would like to load basic profile if the getBasicProfile flag is true or user has been authenticated but no basic profile is in redux store.
    if (getBasicProfile == true) {
      let setPubnubHeartbeatCB = (basicProfile) => {
        // Set pubnub lastheartbeatUTC when get basicinfo during login
        const currentLocalUtc = moment.utc().unix();
        dispatcher(setPubnubHeartbeatReceived(currentLocalUtc, dispatcher));
        gotBasicProfile(basicProfile);
      };
      if (updateLastHeartbeatUTC) {
        dispatcher(getUserBasicProfile(setPubnubHeartbeatCB));
      } else {
        dispatcher(getUserBasicProfile(gotBasicProfile));
      }
    } else {
      //We will return to Promise the user profile we got inside the store
      gotBasicProfile(userProfile);
    }
  });
};

let canIUseVCMErrorMsgCallBack = () => {
  window.location.href = '/login';
};

const verifyChangeEmailRequestLink = (dispatcher) => {
  window.sessionStorage.removeItem('userWantedPage');
  let urlParams = new URLSearchParams(window.location.search);
  let apiParams = `authenticate/authToken/${urlParams.get('t')}`;
  fc.get(window.APP.CONFIGURATION.VCCAPI + apiParams)
    .then((data) => {
      dispatcher(updateUserProfileWithNewEmail(data.email));
      if (loggedIn()) {
        clearUserDetails();
        stopPubnubHealthMonitor(dispatcher);
      }
      return;
    })
    .catch((err) => {
      dispatcher(
        displayGlobalMessage({
          text: APP.LANGUAGE.ServerErrors.InvalidChangeEmailRequest,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
      redirectToInternalLink('/login');
    });
};

export {
  authorize,
  getToken,
  getAuthHeaders,
  setToken,
  logout,
  loggedIn,
  isUserOnLoginPage,
  isUserOnUserProfilePage,
  canIUseVCM,
  userRedirectPageAfterLogin,
  redirectUserToWAAfterLogin,
  redirectUserToOrgUnitfterLogin,
  redirectUserToWaitingAreasfterLogin,
  setAuthenticationDetails,
};
